import { Selector, State } from "./types";
import { TagsScope, Id } from "@planzone/dto";

function createSelector(getState: () => State): Selector {
  const isSameScope = (scope?: TagsScope, scopeId?: Id) => {
    const state = getState();
    return state.scope === scope && state.scopeId === scopeId;
  };

  return {
    getProjectsElementsTags(scope?: TagsScope, scopeId?: Id) {
      return isSameScope(scope, scopeId) ? getState().tags : [];
    },
    isRetrieveProjectsElementsTagsRequestFailure(
      scope?: TagsScope,
      scopeId?: Id,
    ) {
      return isSameScope(scope, scopeId) ? getState().request.isFailure : false;
    },
    isRetrieveProjectsElementsTagsRequestPending(
      scope?: TagsScope,
      scopeId?: Id,
    ) {
      return isSameScope(scope, scopeId) ? getState().request.isPending : false;
    },
    isRetrieveProjectsElementsTagsRequestSuccess(
      scope?: TagsScope,
      scopeId?: Id,
    ) {
      return isSameScope(scope, scopeId)
        ? getState().request.isSuccessful
        : false;
    },
  };
}

export { createSelector };
